<template>
  <v-expansion-panels
    v-if="!paneles_multiples"
    class="ca-expansion-panels"
    :readonly="readonly"
    v-model="panel_abierto_copy"
    :disabled="deshabilitado"
    :focusable="focus_header">
    <slot></slot>
  </v-expansion-panels>
  <v-expansion-panels
    v-else class="ca-expansion-panels"
    :readonly="readonly"
    multiple
    :disabled="deshabilitado"
    :focusable="focus_header">
    <slot></slot>
  </v-expansion-panels>
</template>
<script>
/**
   Wrapper de VExpansionPanels (https://vuetifyjs.com/en/components/expansion-panels),
   este componente se debe utilizar en conjunto con CAPanel (donde se define el contenido de cada panel),
   Uso:
   <ca-expansion-panels>
   <ca-panel>...</ca-panel>
   <ca-panel>...</ca-panel>
   <ca-panel>...</ca-panel>
   </ca-expansion-panels>
   */
export default {
  props: {
    deshabilitado: {type: Boolean, default: false}, //Deshabilita todas las opciones
    focus_header: {type: Boolean, default: true}, //Se destaca el header del panel habilitado.
    panel_abierto: {type: Number, default: null}, //Index (0..n) del panel activo
    readonly: {type: Boolean, default: false},
    paneles_multiples: {type: Boolean, default: false} //permite abrir varios paneles a la vez
  },
  data() {
    return {
      panel_abierto_copy: this.panel_abierto
    };
  },
  watch: {
    panel_abierto_copy(val) {
      this.$emit('update:panel_abierto', val);
    },
    panel_abierto(val) {
      this.panel_abierto_copy = val;
    }
  }
};
</script>
<style lang="scss">
  .ca-expansion-panels {
    margin: 0; //Fix de common.css (Base vieja foundation), ToDo eliminar
    box-shadow: none;
  }
</style>
